import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiEmployeeRecognition,
  ApiEmployeeRecognitionFilter,
  ApiEmployeeRecognitionGift,
  ApiEmployeeRecognitionsSearchData,
  ApiEmployeeRecognitionUpdate,
} from "@/types/recognitions/recognition.types.ts";

export const apiEmployeeRecognitions = {
  search(employeeId: number, filter: ApiEmployeeRecognitionFilter) {
    return api.post<ApiEmployeeRecognitionsSearchData>(
      `/api/v1/employees/${employeeId}/recognitions/search`,
      filter
    );
  },
  gift(employeeId: number, payload: ApiEmployeeRecognitionGift) {
    return api.post<ApiOperationResult>(`/api/v1/employees/${employeeId}/recognitions`, payload);
  },
  update(employeeId: number, itemId: number, payload: ApiEmployeeRecognitionUpdate) {
    return api.put<ApiEmployeeRecognition>(
      `/api/v1/employees/${employeeId}/recognitions/${itemId}`,
      payload
    );
  },
  revoke(employeeId: number, itemId: number) {
    return api.delete<ApiOperationResult>(`/api/v1/employees/${employeeId}/recognitions/${itemId}`);
  },
};
